import dayjs from '~~/src/helpers/dayJs';
import type { PostPage } from '~~/src/server/transformers/page/postPage';
export default function getPostPageSchema(page: PostPage): any {
  const datePublished = dayjs(page.post.date ?? dayjs()).format();
  /**
   * @TODO Add dateModified
   */
  return [
    defineArticle({
      headline: page.post.title,
      description: page.post.description,
      potentialAction: 'ReadAction',
      keywords: page.post.tags?.map((x) => x.title)?.join(',') as any,
      isAccessibleForFree: true,
      audience: [
        'dentists',
        'dentalAssistants',
        'assistantDentists',
        'dentalAdministrativeAssistants',
      ],
      image: page.post.image?.mobile.url,
      datepublished: datePublished,
      author: page.post.author
        ? {
            name: `${page.post.author.firstName} ${page.post.author.lastName} `,
          }
        : null,
    }),
  ];
}
